import { configureApiClient } from '@nohara/react-core';
import { getAuthToken } from '@nohara/react-oidc';

import { env } from '@/config/env';
import { paths } from '@/config/paths';

export const api = configureApiClient({
  baseURL: env.API_ENDPOINT + '/v1',
  getAuthToken: async () => getAuthToken(),
  onUnauthorized: () => {
    const searchParams = new URLSearchParams(window.location.search);
    const redirectTo =
      searchParams.get('redirectTo') || encodeURIComponent(window.location.pathname);
    window.location.href = paths.auth.login.getHref(redirectTo);
  },
});
